export default __webpack_public_path__ + "static/media/oneplace.9b86f7d5.svg";